import { createContext } from "react";

const studylistContext = createContext();

export default studylistContext;